import { AuthContext } from '@core/shared';
import { Cancel, ContainerDefault, Email, ErrorMessagePage, Heading, LinkIcon, MailList, PlannedDurationIcon, Translation, UserAdd } from '@core/ui';
import { LinkCard } from '@online-webinar/ui-frontend';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

export const ManageOverviewPage = () => {
    const {
        canInviteAccounts,
        canManageEmailStyle,
        canManageEmailTemplates,
        canManageTranslations,
        canManageEmailLists,
        canManageBlacklist,
        canManageChatLinkDomains,
        canViewUsageStatistics
    } = useContext(AuthContext);

    const canManage =
        canInviteAccounts ||
        canManageEmailStyle ||
        canManageEmailTemplates ||
        canManageTranslations ||
        canManageEmailLists ||
        canManageBlacklist ||
        canManageChatLinkDomains ||
        canViewUsageStatistics;
    if (!canManage) return <ErrorMessagePage statusCode={401} />;

    const { t } = useTranslation();

    return (
        <ContainerDefault>
            <Heading variant="h1" classNames="mb-8 md:mb-10">
                {t('Manage.PageHeading')}
            </Heading>
            <ul className="max-w-300 grid sm:grid-cols-cards gap-4 md:gap-6">
                {canManageEmailStyle && (
                    <LinkCard
                        icon={<Email classNames="h-14 w-auto mt-2 mb-3 stroke-card-icon" />}
                        to="/manage/email-style"
                        title={t('Email.Style.PageHeading')}
                    />
                )}
                {canManageEmailTemplates && (
                    <LinkCard
                        icon={<Email classNames="h-14 w-auto mt-2 mb-3 stroke-card-icon" />}
                        to="/manage/email-template/$templateType"
                        params={{ templateType: 'AccountVerification' }}
                        linkText={t('Manage.Link.EmailTemplates')}
                        title={t('Email.Template.PageHeading')}
                    />
                )}
                {canManageTranslations && (
                    <LinkCard
                        icon={<Translation classNames="h-14 w-auto mt-2 mb-3 stroke-card-icon" />}
                        to="/manage/translation"
                        linkText={t('Manage.Link.Translation')}
                        title={t('Translation.PageHeading')}
                    />
                )}
                {canInviteAccounts && (
                    <LinkCard
                        icon={<UserAdd classNames="h-14 w-auto mt-2 mb-3 stroke-card-icon" />}
                        to="/manage/account-invites"
                        linkText={t('Manage.Link.AccountInvites')}
                        title={t('AccountInvites.PageHeading')}
                    />
                )}
                {canManageEmailLists && (
                    <LinkCard
                        icon={<MailList classNames="h-14 w-auto mt-2 mb-3 stroke-card-icon" />}
                        to="/manage/email-lists"
                        linkText={t('Manage.Link.EmailLists')}
                        title={t('EmailLists.PageHeading')}
                    />
                )}
                {canManageBlacklist && (
                    <LinkCard
                        icon={<Cancel classNames="h-14 w-auto mt-2 mb-3 stroke-card-icon" />}
                        to="/manage/blacklist"
                        linkText={t('Manage.Link.Blacklist')}
                        title={t('Blacklist.PageHeading')}
                    />
                )}
                {canViewUsageStatistics && (
                    <LinkCard
                        icon={<PlannedDurationIcon classNames="h-14 w-auto mt-2 mb-3 stroke-card-icon" />}
                        to="/manage/usage-statistics"
                        linkText={t('Manage.Link.UsageStatistics')}
                        title={t('UsageStatistics.PageHeading')}
                    />
                )}
                {canManageChatLinkDomains && (
                    <LinkCard
                        icon={<LinkIcon classNames="h-14 w-auto mt-2 mb-3 stroke-card-icon" />}
                        to="/manage/chat-link-domains"
                        linkText={t('Manage.Link.ChatLinkDomains')}
                        title={t('ChatLinkDomains.PageHeading')}
                    />
                )}
                <LinkCard
                    icon={<PlannedDurationIcon classNames="h-14 w-auto mt-2 mb-3 stroke-card-icon" />}
                    to="/manage/webinar-duration"
                    linkText={t('Manage.Link.WebinarDuration')}
                    title={t('WebinarDurationSettings.PageHeading')}
                />
            </ul>
        </ContainerDefault>
    );
};
